module.exports = __webpack_public_path__ + "static/AboutPckitUp2-609ce1dc75709ad8ebdeb5f7c2fafb84.mp4";